import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchBigData, { DefaultState } from "../components/SearchBigData";
import {
  ConfirmsDeleteAction,
  GetCreateTable,
  GetListForm,
  ShowsEditor,
} from "../../core/Helper2";
import { GetRunningDocu, LoadDocuList } from "../../core/BillingComponents";
import FormAutoObject from "../../core/FormAutoObject";
import { FormObjectService } from "../../core/FieldObject";
import { GetDFPaymentHeaderObject } from "../../core/PaymentDFComponent";
import {
  AlertError,
  AlertOK,
  CheckMessageError,
  CreateTooltip,
  FormatCurrency,
  GetHeaderStyle,
  GetNormalStyle,
  GetShortDateNum,
  GetThaiZoneDate,
  XButton,
} from "../../core/Helper";
import { textFilter } from "react-bootstrap-table2-filter";
import ConfirmDialogB, { ConfirmDefault } from "../components/ConfirmDialogB";
import { Oval } from "react-loading-icons";
import styled from "styled-components";

import { Tab, Tabs } from "react-bootstrap";
import { DefaultEditorValue } from "./AdminMonthlyWork";
import { FormType } from "../../model/backoffice/document-type";
import { WebSearchHelperService } from "../tools/search-helper";
import { encode } from "js-base64";
import { RadiMiniColumns, StaffService } from "../../model/staff";
import { LiaUserTieSolid } from "react-icons/lia";
import * as XLSX from "xlsx";
import {
  DocumentService,
  SearchDFRadPay,
} from "../../model/backoffice/document";
import BillViewer, {
  FormDocuType,
} from "../../components/bill-forms/BillViewer";
import DfRadPayConfirm from "./DfRadPayConfirm";
import { BsPersonCircle } from "react-icons/bs";

import { FormSelectBlack } from "../components/PageParams";
import OfficeFormToolbar, {
  OfficeFormToobarHeader,
} from "../tools/OfficeFormToolbar";
import { BiRepeat, BiSearch } from "react-icons/bi";
import { FcApproval } from "react-icons/fc";
import { BranchService } from "../../model/branch";
import { VscCheck } from "react-icons/vsc";
import MonthSelector from "../../core/MonthSelector";
import { DFService } from "../../model/backoffice/df-ratio";
import { GetThaiDateTime2 } from "../../core/ThaiDate";
import { getDatesRange } from "../../core/MyCalendar";
import { FiUserCheck } from "react-icons/fi";

export default function DFPayment(props) {
  const user = useSelector((state) => state.user);
  const [winState, setWinState] = props.list;
  const [table, setTable] = useState(null);
  const [data, setData] = useState([]);
  const [payItems, setPayItems] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [rdoList, setRdoList] = useState([]);
  const [tbRadi, setTbRadi] = useState(null);
  const [tbRadiItems, setTbRadiItem] = useState(null);

  const [curRadi, setCurRadi] = useState(null);
  const [curBranch, setCurBranch] = useState(null);

  const [findOb, setFindOb] = useState(null);
  const [searchBig, setSearchBig] = useState(DefaultState);
  const [findState, setFindState] = useState(dfSearchState({}));
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);

  const [conditWin, setConditWin] = useState(DefaultEditorValue);
  const [confirm, setConfirm] = useState(ConfirmDefault);
  const [loading, setLoading] = useState(false);
  const [loadingRadi, setLoadingRadi] = useState(false);
  const dispatch = useDispatch();

  /** Document components */
  const [docuData, setDocuData] = useState(null);
  const [curDocu, setCurDocu] = useState(null);
  const [docuList, setDocuList] = useState([]);
  const [objHead1, setobjHead1] = useState(null);
  const [objHead2, setobjHead2] = useState(null);
  const [objHead3, setobjHead3] = useState(null);
  const [runningDocu, setRunningDocu] = useState();
  const [billViewer, setBillViewer] = useState();
  // const [billItems, setBillItems] = useState();
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const documentIdFieldName = "PayDfDocuId";

  const [payConfirm, setPayConfirm] = useState(null);

  const [monthInfo, setMonthInfo] = useState({});

  useEffect(() => {
    if (monthInfo != null) {
      changeDateRange(monthInfo.dates);
    }
  }, [monthInfo]);
  /** indecator */
  const [saving, setSaving] = useState(false);

  const setConditionWindow = (conditId) => {
    if (conditId <= 0) {
      return;
    }
    ShowsEditor(
      setConditWin,
      "DfConditId",
      conditId,
      () => {
        setConditWin(DefaultEditorValue);
      },
      null,
      null,
      true
    );
  };

  const reCalculateDF = (row) => {
    // if (!IsCanApprove(user.userRule, dispatch)) return;

    ConfirmsDeleteAction(
      setConfirm,
      async () => {
        setLoading(true);
        let ret = await DFService.ReCalculateDF(
          { pacs_study_id: row.pacs_study_id },
          user.detail
        );
        if (ret) {
          // console.log(docuData);
          if (docuData?.[documentIdFieldName] > 0) {
            loadOldDocument();
          } else {
            loadData();
          }
        }
        setLoading(false);
      },
      "ยืนยันการตรวจสอบราคา"
    );
  };

  useEffect(() => {
    if (winState.show) {
      /** 1. โหลดเอกสาร */
      //clearRef();
      // setDocuData({});
      LoadDocuList([user.detail, setDocuList], FormType.PAYDF_RAD);

      setFindState(dfSearchState({ setConditionWindow, reCalculateDF }));
      loadBranch();
      setCurDocu({ [documentIdFieldName]: 0 });
      // setBillItems([]);
      setPayConfirm(DefaultEditorValue);

      return () => {
        console.log("return ....");
        clearRef();
        setData([]);
        setFindOb(null);

        setSearchBig(null);
        setTable(null);
        setTbRadi(null);
        setCurRadi(null);
        // setCurComp(null);
        // setCompList([]);
        setRdoList([]);
        setConditWin(null);
        setLoading(false);
        setCsv(null);
        setDocuList(null);
        setDocuData({});
        setRunningDocu(null);
        setCurDocu(null);
        setPayItems([]);
        setPayConfirm(null);
        setobjHead1(null);
        setobjHead2(null);
        setobjHead3(null);
        setTbRadiItem(null);
        setMonthInfo(null);
      };
    }
  }, [winState?.show]);

  //useEffect(() => {}, [docuList]);

  useEffect(() => {
    if (winState?.show) {
      addNewBill();
    }
  }, [docuList]);

  /**1. สร้างหัวเอกสารตอนโหลด */
  useEffect(() => {
    if (winState?.show) {
      buildHeader([setobjHead1], 1, ref1);
      buildHeader([setobjHead2], 2, ref2);
      buildHeader([setobjHead3], 3, ref3);
    }
  }, [
    // docuList,
    // docuData?.DocuNo,
    // docuData?.Staff,
    // docuData?.Amount,
    // docuData?.IsCompleted,
    // docuData?.DocuDueDate,
    docuData,
  ]);

  // /** TEST */
  // useEffect(() => {
  //   console.log("Docu Data", docuData);
  // }, [docuData]);
  // useEffect(() => {
  //   console.log(curRadi);
  // }, ["Cur Radi", curRadi]);
  // useEffect(() => {
  //   console.log("CurDocu", curDocu);
  // }, [curDocu]);
  // useEffect(() => {
  //   console.log("COMPANY", curComp);
  // }, [curComp]);
  // useEffect(() => {
  //   console.log("data", data);
  // }, [data]);

  /** รันเลขเอกสาร */
  useEffect(() => {
    if (winState?.show) {
      if (docuData?.DocuBranch) {
        let invId = docuData?.[documentIdFieldName] ?? 0;
        // get latest running no if no invoice-id isfound
        if (invId <= 0) {
          GetRunningDocu([
            docuData,
            setDocuData,
            user.detail,
            setRunningDocu,
            documentIdFieldName,
          ]);
        }
      }
    }
  }, [docuData?.DocuBranch]);

  useEffect(() => {
    if (docuData?.PayItems?.length > 0) {
      setPayItems(docuData?.PayItems);
    }
  }, [docuData?.PayItems]);

  /** สร้างหัวเอกสาร */
  /**  */
  const buildHeader = async ([setter], sectionId, ref) => {
    // ref.current?.reset();
    setter(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetDFPaymentHeaderObject({
              docuList: docuList,
              docuFieldIdName: documentIdFieldName,
              head: docuData,
              sectionId: sectionId,
              disableSlip: true,
              disablePayDate: true,
            })
          ),
          dataValue: [docuData, setDocuData],
          refTo: ref,
        }}
      />
    );
  };

  useEffect(() => {
    if (winState.show) {
      setFindState(dfSearchState({ setConditionWindow, reCalculateDF }));
    }
  }, [loading]);

  /** Load Radiologist reported monthly */
  const loadData = async () => {
    if (curBranch === null || curRadi === null) {
      setData([]);
      return;
    }

    let sql =
      "call rp_radi_df_monthly_payment(" +
      curBranch.BrchID +
      ", '" +
      GetShortDateNum(dateRangeValues[0]) +
      "', '" +
      GetShortDateNum(dateRangeValues[1]) +
      "'," +
      curRadi.Staffid +
      ", 'radi_pay_flag=\\'n\\' ');";

    setLoading(true);
    let res = await WebSearchHelperService.GetBasicReport(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      user.detail
    );
    setLoading(false);
    if (res) {
      setData(res);
    }
  };

  /** Branch List */
  const loadBranch = async () => {
    let res = await BranchService.GetNewList(user.detail);
    if (res?.length > 0) {
      setBranchList(res ?? []);
      //updateCompany(res[0]?.compid);
    }
  };

  const updateCompany = async (brchid) => {
    let brch = await BranchService.GetItem({ BrchId: brchid }, user.detail);
    setCurBranch(brch);
  };

  //** CurRad effected.. */
  useEffect(() => {
    if (winState?.show) {
      setCurRadi(null);
      setRdoList([]);
      setData([]);
      // console.log("Setting... company");
      if (curBranch !== null && docuData !== null) {
        setDocuData((pv) => ({
          ...pv,
          CompanyPay: { CompId: curBranch.CompId },
        }));
      }
    }
  }, [curBranch]);

  useEffect(() => {
    if (curRadi != null && curBranch !== null) {
      loadData();
      setDocuData((pv) => ({
        ...pv,
        ...{
          Staff: curRadi,
          BillTo: curRadi?.FullName,
          Amount: 0,
        },
      }));
    }
  }, [curRadi]);

  //** date-range effected  */
  // useEffect(() => {
  //   if (winState?.show) {
  //     if (curBranch != null && docuData != null) {
  //       // if (docuData?.[documentIdFieldName] === 0)
  //       // loadRadiologistList();
  //     }
  //   }
  // }, [dateRangeValues, curBranch]);

  const updateDocuDateRange = () => {
    setDocuData((pv) => ({
      ...pv,
      WorkDateFrom: GetThaiZoneDate(dateRangeValues[0]),
      WorkDateTo: GetThaiZoneDate(dateRangeValues[1]),
    }));
  };

  const radSelected = async (row, isSelect, rowIndex) => {
    let radi = await StaffService.GetStaffNew(
      { StaffId: row.staffid },
      user.detail
    );
    setCurRadi(radi);
  };
  //** Rad-list effected */
  useEffect(() => {
    if (winState.show) {
      setTbRadi(
        GetCreateTable({
          idFieldName: "staffid",
          columns: RadiMiniColumns,
          data: rdoList,
          pageOptionProps: { hideSizePerPage: true },

          selectRow: {
            mode: "radio",
            clickToSelect: true,
            class: "row-h-over-selected",
            hideSelectColumn: true,
            style: { background: "var(--tb-bg-selected)" },
            onSelect: radSelected,
          },
        })
      );
    }
  }, [rdoList]);

  //** load rad function */
  const loadRadiologistList = async (props) => {
    if (curBranch === null) {
      AlertError("กรุณาเลือกสาขา", dispatch);
      return;
    }
    setCurRadi(null);
    let sql =
      "call rp_rdo_list_payment(" +
      curBranch.BrchID +
      ", '" +
      GetShortDateNum(dateRangeValues[0]) +
      "', '" +
      GetShortDateNum(dateRangeValues[1]) +
      "', 'radi_pay_flag=\\'n\\' ')";
    setLoadingRadi(true);

    let res = await WebSearchHelperService.GetBasicReport(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      user.detail
    );
    setLoadingRadi(false);

    setData([]);

    if (res) {
      setRdoList(res);
    }

    updateDocuDateRange();
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      e.preventDefault();
      winState.action(row, winState);
    },
  };

  const [csv, setCsv] = useState(null);
  useEffect(() => {
    if (winState?.show && data) {
      setTable(
        GetCreateTable({
          idFieldName: "item_id",
          columns: findState?.columns,
          rowEvents: rowEvents,
          data: data ?? [],
          // selectRow: selectItemRow,
          pageOptionProps: { hideSizePerPage: true },
        })
      );
    }
  }, [data, winState]);

  useEffect(() => {
    if (winState?.show) {
      setTbRadiItem(
        GetCreateTable({
          idFieldName: "item_id",
          columns: RadiItemColumns({}),
          //rowEvents: rowEvents,
          data: payItems ?? [],
          // selectRow: selectItemRow,
          pageOptionProps: { hideSizePerPage: true },
        })
      );
    }
  }, [payItems]);

  useEffect(() => {
    if (winState?.show) {
      sumAll();
    }
  }, [table]);

  const sumAll = () => {
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      sum += Number(data[i]?.df_fee);
    }

    setDocuData((pv) => ({ ...pv, Amount: sum }));

    // setPayItems(items);
    //}
  };

  const exportToExcel = async () => {
    //const buildExcel = new Promise((resolve, reject) => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, curRadi?.FullName + ".xlsx");
    //resolve(true);
    //});
    setLoading(true);
    //let ret = await buildExcel();
    setLoading(false);
  };

  const addNewBill = () => {
    clearRef();
    setDocuData({});
    setCurDocu(null);
    setData([]);
    /** Load Radiologist */
    // loadRadiologistList();
    setRdoList([]);
    setData([]);
  };
  const clearRef = () => {
    ref1.current?.reset();
    ref2.current?.reset();
    ref3.current?.reset();
  };
  const searchClick = () => {
    SearchDFRadPay([
      setSearchBig,
      curDocu,
      setCurDocu,
      user.detail,
      {
        fieldName: documentIdFieldName,
      },
    ]);
  };

  const checkBeForeSave = async () => {
    if (data === null || docuData === null) {
      AlertError("ไม่พบรายการ", dispatch);
      return;
    }

    if (!docuData?.Amount) {
      AlertError("ไม่มียอดจ่าย กรุณาตรวจสอบ", dispatch);
      // console.log("check data", docuData);
      return;
    }

    for (var i = 0; i < data.length; i++) {
      if (data[i].df_fee === 0) {
        ConfirmsDeleteAction(
          setConfirm,
          (e) => {
            saveData();
          },
          <div>
            <div>พบบางรายการยังไม่ได้คำนวณ DF</div>
            <div>ต้องการดำเนินการต่อหรือไม่</div>
          </div>
        );
        return;
      }
    }

    saveData();
  };

  /** บันทึกข้อมูล */
  const saveData = async () => {
    setLoading(true);
    let ret = await DocumentService.SaveDFRadPay(
      {
        ...docuData,
        BranchPay: { ...docuData.BranchPay, ...curBranch },
        DocuBranch: runningDocu,
        SudyItems: data,
        DateRange: dateRangeValues,
        PayItems: payItems,
        RoundPeriod: monthInfo,
      },
      user.detail
    );

    AlertOK("บันทึกเอกสารเรียบร้อย", dispatch);
    if (ret?.IsCompleted === false) {
      ret.CompleteDate = null;
    }
    setDocuData(ret);
    setLoading(false);
  };

  useEffect(() => {
    console.log("cur docu", curDocu);
    if (
      winState?.show &&
      curDocu !== null &&
      docuData?.[documentIdFieldName] !== undefined
    ) {
      if (curDocu !== docuData?.[documentIdFieldName]) {
        loadOldDocument();
      }
    }
  }, [curDocu]);

  /** โหลดเอกสารเก่า */
  const loadOldDocument = async () => {
    clearRef();
    let res = await DocumentService.GetDFRadPay(curDocu, user.detail);

    if (!CheckMessageError(res)) {
      if (res?.IsCompleted === false) {
        res.CompleteDate = null;
      }

      setDocuData(res);
      // setMonthInfo((pv) => ({
      //   year: res?.PeriodYear,
      //   month: res?.PeriodMonth,
      //   dates: getDatesRange(res?.PeriodYear, res?.PeriodMonth),
      // }));

      loadSavedItems(curDocu?.[documentIdFieldName]);
    }
  };

  // useEffect(() => {
  //   console.log("check docu data", docuData);
  // }, [docuData]);

  /** โหลดรายละเอียดเอกสารเกำ */
  const loadSavedItems = async (payDfDocuId) => {
    if (payDfDocuId === undefined) return;
    setLoading(true);
    let res = await DocumentService.GetPaymentRadPayDetail(
      payDfDocuId,
      user.detail
    );
    setLoading(false);

    if (res) {
      setData(res);
    }
  };

  /** แสดงหน้าจอพิมพ์ */
  const printData = () => {
    setBillViewer((pv) => ({
      ...pv,
      show: true,
      formDocuType: FormDocuType.PAY_DF_RAD,
    }));
  };

  /**  */
  const setShowPayConfirm = () => {
    setPayConfirm((pv) => ({ ...pv, show: true }));
  };

  /** ลบใบ payment */
  const deleteData = async () => {
    if (!docuData?.[documentIdFieldName]) {
      return;
    } else {
      ConfirmsDeleteAction(
        setConfirm,
        (e) => {
          deletes();
        },
        <div>
          <div>ต้องการยกเลิกรายการ</div>
          <div>กรุณายืนยัน</div>
        </div>
      );
    }
  };

  const deletes = async () => {
    let ret = await DocumentService.CancelDFRadPay(
      {
        PayDfDocuId: docuData?.[documentIdFieldName],
      },
      user.detail
    );

    clearRef();
    setDocuData({});
    setCurDocu(null);
  };

  const finalPayment = () => (
    <FinalBox>
      <XButton onMouseUp={() => setShowPayConfirm()}>
        <VscCheck
          color="var(--icon-fore)"
          style={{ marginRight: "15px" }}
          size={25}
        />{" "}
        ปรับปรุงสลิปโอน
      </XButton>
    </FinalBox>
  );

  return (
    <>
      <GetListForm
        {...{
          list: [winState, setWinState],
          size: "lg",
          title: winState?.title ?? "ออกเอกสารการจ่ายค่าตอบแทนแพทย์",
          fullscreen: true,
          icon: (
            <LiaUserTieSolid
              color="var(--icon-fore)"
              style={{ marginInlineEnd: "10px" }}
              size={30}
            />
          ),
        }}
      >
        <OfficeFormToolbar
          {...{
            addNewBill,
            searchClick,
            saveData: checkBeForeSave,
            printData,
            deleteData,
            saving,
            addButtonTitle: "เพิ่มใบสรุปจ่าย",
            searchButtonTitle: "ค้นหาใบสรุปจ่าย",
            saveButtonTitle: "บันทึกเอกสาร",
          }}
        />
        <OfficeFormToobarHeader
          {...{
            objHead1,
            objHead2,
            // objHead3: docuData?.IsCompleted ? objHead3 : null,
            objHead3,
            title: "ยอดค่ารายจ่ายรวม",
            data: docuData,
            netFieldName: "Amount",
            objAdd1: docuData?.PayDfDocuId ? finalPayment() : null,
          }}
        />

        {!docuData?.PayDfDocuId ? (
          <TopBox>
            <MonthSelector info={[monthInfo, setMonthInfo]} />
            <HBox></HBox>
            <HBox>
              <span style={{ marginInline: "10px" }}>โรงพยาบาล</span>
              <FormSelectBlack
                style={{ width: "200px" }}
                {...{
                  rows: branchList ?? [],
                  fieldId: "BrchID",
                  fieldValue: "BrchName",
                  // addFirstRow: true,
                  // firstRowText: "เลือกบริษัท",
                }}
                onChange={(e) => updateCompany(e.target.value)}
              />
              <XButton
                marginInline="10px"
                onMouseUp={() => loadRadiologistList()}
              >
                {" "}
                <BiSearch
                  size={20}
                  title="ค้น"
                  color="var(--icon-fore)"
                  style={{ marginInlineEnd: "10px" }}
                />{" "}
                แสดงข้อมูลแพทย์
              </XButton>
            </HBox>
          </TopBox>
        ) : (
          <></>
        )}

        <MainDiv>
          {!docuData?.PayDfDocuId ? (
            <LeftDiv>
              <SelectPanel>
                {loadingRadi ? (
                  <HBox>
                    <Oval height={20} /> ค้นหาแพทย์ที่อ่านผล ...
                  </HBox>
                ) : (
                  <div>
                    <HBox style={{ color: "var(--caption-fore-color)" }}>
                      รายชื่อรังสีแพทย์ส่งผลอ่าน
                    </HBox>
                    <HBox style={{ color: "var(--page-total-text-color)" }}>
                      เลือกแพทย์ทำรายการจ่าย{" "}
                    </HBox>
                  </div>
                )}

                <MenuContent>{tbRadi}</MenuContent>
              </SelectPanel>
            </LeftDiv>
          ) : (
            <></>
          )}
          <CenterDiv>
            <RadBox>
              <div style={{ height: "25px" }}>
                <HBox>
                  {loading ? (
                    <span>
                      {" "}
                      <Oval height={20} /> กำลังค้นรายการอ่านผลสำหรับ{" "}
                    </span>
                  ) : (
                    <BsPersonCircle
                      color="var(--icon-fore)"
                      size={30}
                      style={{ marginInline: "10px" }}
                    />
                  )}
                  {`${curRadi?.FullName ?? docuData?.Staff?.FullName ?? ""}`}
                </HBox>
              </div>

              <DivApprove onMouseUp={exportToExcel}>
                {CreateTooltip(
                  "เลือกนับเฉพาะรายการที่มีการยืนยันยอดค่าตอบแทนแล้ว",
                  <XButton
                    style={{
                      margin: "5px",
                    }}
                  >
                    <FcApproval size={25} /> {`ส่งข้อมูลออก Excel`}
                  </XButton>
                )}
              </DivApprove>
            </RadBox>

            {/* {csv} */}
            <Tabs defaultActiveKey={"study"}>
              <Tab
                title={
                  <>
                    <FiUserCheck size={25} color="var(--icon-fore)" />{" "}
                    รายชื่อคนไข้
                  </>
                }
                eventKey={"study"}
              >
                <TTab>{table}</TTab>
              </Tab>
            </Tabs>
          </CenterDiv>
        </MainDiv>
      </GetListForm>

      <SearchBigData {...{ winState: [searchBig, setSearchBig] }} />

      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
      <DfRadPayConfirm
        {...{
          editor: [payConfirm, setPayConfirm],
          docuData,
          setDocuData,
          docuFieldIdName: documentIdFieldName,
        }}
      />
      <BillViewer
        {...{
          billViewer: [billViewer, setBillViewer],
          data: [docuData, setDocuData],
          items: data ?? [],
        }}
      />
      {loading || loadingRadi ? <Oval /> : <></>}
    </>
  );
}

const dfSearchState = (props) => {
  const columns = dfPayDetailcolumns(props);
  return {
    size: "sm",
    show: false,
    fieldId: "item_id",
    fieldName: "",
    columns: columns,
    action: (e) => {
      alert(e);
    },
  };
};

export const dfPayDetailcolumns = (props) => {
  const { reCalculateDF } = props;
  return [
    {
      dataField: "request_date",
      text: "ส่งอ่าน",
      sort: true,
      headerStyle: GetHeaderStyle("90px"),
      style: () => GetNormalStyle("center"),
      filter: textFilter({ placeholder: "..." }),
      formatter: (cell, row) => GetThaiDateTime2({ dateValue: cell }),
    },
    // {
    //   dataField: "study_time",
    //   text: "เวลา",
    //   sort: true,
    //   headerStyle: GetHeaderStyle("50px"),
    //   style: () => GetNormalStyle("center"),
    //   filter: textFilter({ placeholder: "..." }),
    // },

    {
      dataField: "patients_name",
      text: "คนไข้",
      sort: true,
      headerStyle: GetHeaderStyle("auto"),
      style: () => GetNormalStyle("left"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "hn",
      text: "HN",
      sort: true,
      headerStyle: GetHeaderStyle("120px"),
      style: () => GetNormalStyle("center"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "brchshort",
      text: "รพ.",
      sort: true,
      headerStyle: GetHeaderStyle("auto"),
      style: () => GetNormalStyle("left"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "brchright_name",
      text: "สิทธิการรักษา",
      sort: true,
      headerStyle: GetHeaderStyle("auto"),
      style: () => GetNormalStyle("left"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "item_name",
      text: "ส่วนตรวจ",
      sort: true,
      headerStyle: GetHeaderStyle("auto"),
      style: () => GetNormalStyle("left"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "item_code",
      text: "รหัสกรม",
      sort: true,
      headerStyle: GetHeaderStyle("80px"),
      style: () => GetNormalStyle("center"),
      filter: textFilter({ placeholder: "..." }),
    },
    {
      dataField: "price",
      text: "ราคาตรวจ",
      sort: true,
      hidden: true,
      headerStyle: GetHeaderStyle("80px"),
      style: () => GetNormalStyle("right"),
      filter: textFilter({ placeholder: "..." }),
      formatter: FormatCurrency,
    },
    {
      dataField: "df_fee",
      text: "DF",
      sort: true,
      headerStyle: GetHeaderStyle("80px"),
      style: () => GetNormalStyle("right", "var(--icon-fore)"),
      formatter: FormatCurrency,
    },
    {
      dataField: "",
      isDummyField: true,
      headerStyle: GetHeaderStyle("50px"),
      style: () => GetNormalStyle("center", "var(--icon-fore)"),
      formatter: (cell, row, rowIndex) => (
        <XButton onMouseUp={() => reCalculateDF(row)}>
          {CreateTooltip(
            "คำนวณใหม่",
            <div>
              <BiRepeat size={20} />
            </div>
          )}
        </XButton>
      ),
    },
  ];
};

const RadiItemColumns = (props) => [
  {
    dataField: "RowNo",
    text: "ลำดับ",
    sort: true,
    headerStyle: GetHeaderStyle("50px"),
    style: () => GetNormalStyle("center"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "ItemName",
    text: "ชื่อรายได้",
    sort: true,
    headerStyle: GetHeaderStyle("auto"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "ItemQty",
    text: "จำนวน",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("right", "var(--icon-fore)"),
    formatter: FormatCurrency,
  },
  {
    dataField: "ItemPrice",
    text: "หน่วยละ",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("right", "var(--icon-fore)"),
    formatter: FormatCurrency,
  },
  {
    dataField: "ItemAmount",
    text: "รวม",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("right", "var(--icon-fore)"),
    formatter: FormatCurrency,
  },
];

export const TTab = styled.div`
  /* margin-block: 15px; */
  /* padding-block: 15px; */
  display: flex;
  flex-direction: column;
  min-height: 250px;

  background-color: var(--tab-bg-active);
`;

const FinalBox = styled.div`
  font-size: 20px;
`;

const TopBox = styled.div`
  display: flex;
  background: linear-gradient(
    0deg,
    var(--bg-primary) 0%,
    var(--bg-secondary) 90%
  );
  padding-block: 10px;
  color: var(--caption-fore-color);
  justify-content: center;
`;

const CenterDiv = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  padding-inline-start: 5px;
`;

export const RadBox = styled.div`
  padding-block: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: var(--page-total-text-color);
  background-color: var(--bg-secondary);
  border-radius: 5px;
`;

const HBox = styled.div`
  margin-inline: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const MainDiv = styled.div`
  padding-block-start: 10px;
  flex: 1;
  display: flex;
  flex-direction: row;
`;

const LeftDiv = styled.div`
  display: flex;
  width: 380px;
  padding-block-end: 10px;
  padding-inline: 10px;
  flex: 1;
  align-items: start;
  background-color: var(--bg-secondary);
  margin: 1px;
  border-radius: 5px;
`;

const SelectPanel = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  padding: 10px;
  flex-direction: column;
  flex: 1;
`;

const DivApprove = styled.div`
  transition: 300ms;
`;

const MenuContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;
